import api from './api';

export function getBankListApi(cpCode: string, franchiseCode: string) {
  return api.get('/claims/banks/', {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function getCoverageListApi(cpCode: string, franchiseCode: string) {
  return api.get('/coverages/', {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function getCoverageListByTypePDVApi(
  typePDV: string,
  cpCode: any,
  franchiseCode: string,
) {
  return api.get(`/coverages/byPDV/${typePDV}`, {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function getUserDetailsApi() {
  return api.get('/users/');
}

export function getUserRolesApi(): Promise<any> {
  return api.get('/users/roles');
}

export function getUserFranchises(): Promise<any> {
  return api.get('/users/stores');
}

export function getUserFranchiseByCodeApi(code: string, cp: string) {
  return api.get(`/users/franchise/${code}`, {
    headers: {
      'x-cpcode': cp,
      'x-franchise': String(code),
    },
  });
}

export function createClaim(body: any, cpCode: string, franchiseCode: string) {
  return api.post('/claims/', body, {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function updateClaim(
  body: any,
  id: string,
  cpCode: string,
  franchiseCode: string,
) {
  return api.put(`/claims/${id}/`, body, {
    headers: {
      'x-franchise': franchiseCode,
      'x-cpcode': cpCode,
    },
  });
}

export function finishClaimById(
  body: any,
  cpCode: string,
  franchiseCode: string,
) {
  return api.put(`/claims/${body.id}/finish/`, null, {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function uploadFiles({ formData, id }: any, cpCode: string) {
  return api.put(`/claims-files/upload/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'x-cpcode': cpCode,
    },
  });
}

export function deleteFile(
  idClaim: string,
  idFile: string,
  cpCode: string,
  franchiseCode: string,
) {
  return api.put(`/claims-files/upload/remove/${idClaim}/${idFile}/`, null, {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export async function getPresignedPostData(
  fileName: string,
  cpCode: number | string,
  franchiseCode: string,
): Promise<any> {
  const extension = fileName.split('.').pop();
  return api.get(`/claims-files/upload/presignedurl/filename.${extension}`, {
    headers: {
      'x-cpcode': `${cpCode}`,
      'x-franchise': franchiseCode,
    },
  });
}

export async function getPresignedUrl(
  fileName: string,
  cpCode: number | string,
  franchiseCode: string,
): Promise<any> {
  return api.get(`/claims-files/download/presignedurl/${fileName}`, {
    headers: {
      'x-cpcode': `${cpCode}`,
      'x-franchise': franchiseCode,
    },
  });
}

export async function updateUploadedFiles(
  uploadedFiles: any[],
  claimId: string,
  cpCode: number,
  franchiseCode: string,
) {
  return api.put(
    `/claims-files/upload/updateuploadedfiles/${claimId}`,
    uploadedFiles,
    {
      headers: {
        'x-cpcode': `${cpCode}`,
        'x-franchise': franchiseCode,
      },
    },
  );
}
